module.exports = __webpack_public_path__ + "img/dink-white-bathroom-1.7ddf57dc.jpeg";